interface AviProps { size?: number; }
export function Avi({ size = 28 }: AviProps) {
  return (
    <div style={{ width: size, height: size, borderRadius: size * 0.25, background: "#0C2638", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden", padding: size * 0.1 }}>
      <svg viewBox="0 0 224 167" style={{ width: "100%", height: "100%" }}>
        <defs>
          <linearGradient id="ekg" x1="97" y1="-7" x2="144" y2="168" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#4477b7" />
            <stop offset="1" stopColor="#68ca91" />
          </linearGradient>
        </defs>
        <path fill="#4477b7" fillRule="evenodd" d="M167.45,93.17a164,164,0,0,1-38.09,16.65,117.49,117.49,0,0,1,58.33,56.73h36a151.12,151.12,0,0,0-56.28-73.38Z" />
        <path fill="url(#ekg)" fillRule="evenodd" d="M36.24,66.63A50.22,50.22,0,0,1,82.93,33.34a83.35,83.35,0,0,0,66-33.3H83.33A83.64,83.64,0,0,0,1.7,66.63c-10.38,50.6,28,99.34,80.7,99.92h66.5a83.22,83.22,0,0,0-65.61-33.3,50.31,50.31,0,0,1-47.1-33.33H82.4A150.31,150.31,0,0,0,223.73,0h-36c-19,39.77-59.43,66.58-105,66.63Z" />
      </svg>
    </div>
  );
}
